/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScorecardFillGroup } from './scorecardFillGroup';
import type { ScorecardFillsOutResolvedFrom } from './scorecardFillsOutResolvedFrom';

export interface ScorecardFillsOut {
  resolved_from: ScorecardFillsOutResolvedFrom;
  can_see_all: boolean;
  groups: ScorecardFillGroup[];
}
